import * as React from 'react';
import MessageForm, { Props } from './message_form';
import { shallow, ShallowWrapper } from 'enzyme';
import messageableDummy from '__fixtures__/messageable_dummy';

const createTestProps = moreProps => {
  return {
    messageable: messageableDummy,
    userType: '',
    messagesUrl: jest.fn(),
    handleNewConversation: jest.fn(),
    mini: false,
    ...moreProps,
  };
};

let props: Props;
let wrapped: ShallowWrapper;

describe('Message Form component', () => {
  beforeEach(() => {
    props = createTestProps({});
    wrapped = shallow(<MessageForm {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
